export default __webpack_public_path__ + "icons/wave-c44271.svg";